import { Link, Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { useMutation, useQuery } from "@tanstack/react-query";
import { self, signin } from "../../http/auth";
import { toast } from "react-toastify";

const Login = () => {
  const { setUser, setToken, user, setRefreshToken } = useAuthStore();

  const { refetch } = useQuery({
    queryKey: ["self"],
    queryFn: self,
    enabled: false,
    retry: 0,
  });

  const mutation = useMutation({
    mutationFn: signin,
    onSuccess: async (responseData) => {
      setToken(responseData?.data?.accessToken);
      setRefreshToken(responseData?.data?.refreshToken);
      const { data } = await refetch();
      setUser(data?.data?.user);
      return;
    },
    onError: (error) => {
      console.error("Login error:", error);
      let message;
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (!error?.response) {
        message = "Unable to connect to server. Please try again.";
      } else {
        message = "An unexpected error occurred. Please try again.";
      }
      toast.error(message, { autoClose: 5000 });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.currentTarget.email.value;
    const password = e.currentTarget.password.value;
    try {
      mutation.mutate({ email, password });
    } catch (error) {
      console.error("Error logging in: ", error);
      toast.error("Invalid email or password", { autoClose: 5000 });
    }
  };

  if (user) {
    return <Navigate to="/" />;
  }
  return (
    <div className="flex flex-col min-h-[calc(100vh-128px)] items-center justify-center p-6 bg-flyers-black">
      <form
        onSubmit={handleSubmit}
        className="bg-flyers-charcoal text-white p-8 rounded-lg border border-flyers-dark-gray shadow-orange-glow w-full max-w-md"
      >
        <h1 className="font-heading text-2xl font-black uppercase tracking-wide mb-6 text-center text-flyers-orange">
          Login
        </h1>
        <div className="mb-4">
          <label htmlFor="email" className="label mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className="input"
            required
          />
        </div>
        <div className="mb-6">
          <label htmlFor="password" className="label mb-2">
            Password
          </label>
          <input
            type="password"
            id="password"
            name="password"
            className="input"
            required
          />
        </div>
        <button
          type="submit"
          className="bg-flyers-orange w-full hover:bg-flyers-orange-light text-white font-heading font-bold uppercase tracking-wider py-3 px-4 rounded transition-colors duration-150"
          disabled={mutation?.isPending}
        >
          {mutation?.isPending ? "Logging in..." : "Login"}
        </button>

        <p className="mt-6 text-center text-flyers-mid-gray">
          Don't have an account?{" "}
          <Link to="/register" className="text-flyers-orange hover:text-flyers-orange-light transition-colors">
            Register
          </Link>
        </p>
      </form>
    </div>
  );
};
export default Login;
